import type { Error } from '../types';

import {
  TXTWCL_Please_enter_valid_Personal_Nu_ELL,
  TXTWCL_Please_enter_valid_Uniform_Civ_ELL
} from './validatePIN.messages';

export const validatePNF = (value: string): Error => {
  if (!value) return { valid: true };
  if (value.length < 10)
    return { valid: false, message: TXTWCL_Please_enter_valid_Personal_Nu_ELL };
  const isValid =
    +value.slice(-1) ===
    value
      .substring(0, value.length - 1)
      .split('')
      .map((char, index) => +char * [21, 19, 17, 13, 11, 9, 7, 3, 1][index])
      .reduce((a, b) => a + b, 0) %
      10;

  if (!isValid) return { valid: false, message: TXTWCL_Please_enter_valid_Personal_Nu_ELL };
  return { valid: true };
};

export const validateUCN =
  (dob: string) =>
  (value: string): Error => {
    if (!value || !dob) return { valid: true };
    if (value.length < 10)
      return { valid: false, message: TXTWCL_Please_enter_valid_Uniform_Civ_ELL };
    const DOBDataType = new Date(dob);
    const year = DOBDataType.getFullYear();
    const dobValue =
      year.toString().slice(-2) +
      (DOBDataType.getMonth() + (year < 1900 ? 21 : year > 1999 ? 41 : 1))
        .toString()
        .padStart(2, '0') +
      DOBDataType.getDate().toString().padStart(2, '0');
    if (value.substring(0, 6) !== dobValue) {
      return { valid: false, message: TXTWCL_Please_enter_valid_Uniform_Civ_ELL };
    }
    const mod =
      value
        .substring(0, value.length - 1)
        .split('')
        .map((char, index) => +char * [2, 4, 8, 5, 10, 9, 7, 3, 6][index])
        .reduce((a, b) => a + b) % 11;

    const isValid = +value.slice(-1) === (!mod || mod === 10 ? 0 : mod);
    if (!isValid) return { valid: false, message: TXTWCL_Please_enter_valid_Uniform_Civ_ELL };
    return { valid: true };
  };
